/**
 * 任务中心页签提示角标：相对「上次进入页面确认时」的增量。
 * 进入收到的 / 发起的并完成计数拉取后 acknowledge → 角标消除；
 * 停留期间任务变多时仅显示增量。
 */
import { computed, ref, type Ref } from 'vue'

function storageKey(mode: 'received' | 'assigned'): string {
  return `task-inbox-tab-badge-ack:${mode}`
}

function loadAck(mode: 'received' | 'assigned'): Record<string, number> {
  try {
    const raw = sessionStorage.getItem(storageKey(mode))
    if (!raw) return {}
    const parsed = JSON.parse(raw) as Record<string, number>
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

function saveAck(mode: 'received' | 'assigned', value: Record<string, number>) {
  try {
    sessionStorage.setItem(storageKey(mode), JSON.stringify(value))
  } catch {
    // ignore quota / private mode
  }
}

export function useInboxTabBadgeAck(
  mode: 'received' | 'assigned',
  tabCounts: Ref<Record<string, number>>,
) {
  const acknowledged = ref<Record<string, number>>(loadAck(mode))

  const badgeCounts = computed(() => {
    const out: Record<string, number> = {}
    for (const [key, count] of Object.entries(tabCounts.value)) {
      const delta = (count ?? 0) - (acknowledged.value[key] ?? 0)
      if (delta > 0) out[key] = delta
    }
    return out
  })

  /** 进入页面并拿到最新计数后调用：消除提示角标 */
  function acknowledgeTabBadges() {
    acknowledged.value = { ...tabCounts.value }
    saveAck(mode, acknowledged.value)
  }

  return { badgeCounts, acknowledgeTabBadges }
}
